<div class="wrapper" [class.nav-open]="sidebarOpen">
  @if (!fullScreen) {
    <div
      class="sidebar"
      [class.sidebar-open]="sidebarOpen"
      data-color="purple"
      data-background-color="white"
      >
      <app-sidebar></app-sidebar>
    </div>
    <div
      class="sidebar-backdrop"
      [class.visible]="sidebarOpen"
      (click)="closeSidebar()"
    ></div>
  }
  <div class="main-panel" [class.full]="fullScreen">
    @if (!fullScreen) {
      <div class="main-panel-topbar">
        <app-navbar></app-navbar>
      </div>
    }
    <div class="main-panel-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
